import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { tables as initialTables } from '../../data/mockData';
import SafeIcon from '../../common/SafeIcon';
import { FiMaximize2 } from 'react-icons/fi';

const statusColors = {
  open: 'bg-status-open/10 border-status-open/50 text-status-open hover:shadow-glow-green',
  occupied: 'bg-status-occupied/10 border-status-occupied/50 text-status-occupied hover:shadow-glow-red',
  dirty: 'bg-status-dirty/10 border-status-dirty/50 text-status-dirty',
  reserved: 'bg-status-reserved/10 border-status-reserved/50 text-status-reserved',
};

export const FloorPlan = () => {
  const [tables, setTables] = useState(initialTables);
  const [selectedTable, setSelectedTable] = useState(null);

  const handleTableClick = (table) => {
    setSelectedTable(table);
  };

  const updateStatus = (newStatus) => {
    if (!selectedTable) return;
    setTables(tables.map(t => t.id === selectedTable.id ? { ...t, status: newStatus } : t));
    setSelectedTable({ ...selectedTable, status: newStatus });
  };

  return (
    <Card title="Service Heatmap" action={<button className="text-receiptMuted hover:text-receiptWhite"><SafeIcon icon={FiMaximize2}/></button>} className="col-span-1 lg:col-span-2 min-h-[400px]">
      <div className="flex gap-4 h-full">
        {/* Grid */}
        <div className="flex-1 grid grid-cols-4 gap-3 content-start">
          {tables.map(table => (
            <button
              key={table.id}
              onClick={() => handleTableClick(table)}
              className={`relative flex flex-col items-center justify-center p-4 rounded border transition-all duration-200
                ${statusColors[table.status]}
                ${selectedTable?.id === table.id ? 'ring-2 ring-receiptWhite ring-offset-2 ring-offset-chefDark' : ''}
              `}
            >
              <span className="font-mono text-lg font-bold">{table.id}</span>
              <span className="text-[10px] uppercase opacity-80 mt-1 flex items-center gap-1">
                {table.capacity} <SafeIcon icon="Users" className="w-3 h-3" />
              </span>
              {table.status === 'occupied' && (
                <div className="absolute top-1 right-1 w-2 h-2 rounded-full bg-chiliRed animate-pulse" />
              )}
            </button>
          ))}
        </div>

        {/* Selected Table Panel */}
        {selectedTable && (
          <div className="w-64 bg-chefBlack border border-chefPanel rounded-lg p-4 flex flex-col">
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-receiptWhite font-mono text-lg">Table {selectedTable.id}</h4>
              <span className={`text-xs px-2 py-1 rounded uppercase font-mono ${statusColors[selectedTable.status].split(' ')[0]} ${statusColors[selectedTable.status].split(' ')[2]}`}>
                {selectedTable.status}
              </span>
            </div>
            
            <div className="space-y-3 flex-1 text-sm text-receiptMuted">
              <div className="flex justify-between border-b border-chefPanel pb-2">
                <span>Capacity</span>
                <span className="text-receiptWhite">{selectedTable.capacity}</span>
              </div>
              {selectedTable.server && (
                <div className="flex justify-between border-b border-chefPanel pb-2">
                  <span>Server</span>
                  <span className="text-receiptWhite">{selectedTable.server}</span>
                </div>
              )}
              {selectedTable.seatedAt && (
                <div className="flex justify-between border-b border-chefPanel pb-2">
                  <span>Seated</span>
                  <span className="text-receiptWhite">{selectedTable.seatedAt}</span>
                </div>
              )}
            </div>

            <div className="mt-4 grid grid-cols-2 gap-2">
              <button onClick={() => updateStatus('open')} className="py-2 text-xs font-mono border border-status-open text-status-open rounded hover:bg-status-open/10 transition-colors">Set Open</button>
              <button onClick={() => updateStatus('dirty')} className="py-2 text-xs font-mono border border-status-dirty text-status-dirty rounded hover:bg-status-dirty/10 transition-colors">Set Dirty</button>
              <button onClick={() => updateStatus('occupied')} className="py-2 text-xs font-mono border border-status-occupied text-status-occupied rounded hover:bg-status-occupied/10 transition-colors col-span-2">Seat Guests</button>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};